import React from 'react';
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { ADD, GET_BY_PUBLISHER_ID } from "../../../../queries/settings";

const Add = (props) => {
  return (
    <Mutation
      mutation={ADD}
      update={(store, { data: { createSetting } }) => {
        setTimeout(()=>{
        const { settingByPublisherId } = store.readQuery({ query: GET_BY_PUBLISHER_ID, variables:{ publisherId : props.publisherId }});
        store.writeQuery({                                    
          query: GET_BY_PUBLISHER_ID,
          variables: { publisherId : props.publisherId },
          data: { settingByPublisherId: settingByPublisherId.concat(createSetting) }
        });
      }, 3000);
      }}
      refetchQueries={[
        {query:GET_BY_PUBLISHER_ID, variables: { publisherId : props.publisherId }}
      ]}
      awaitRefetchQueries={true}
      >
        
      {createSetting => (
       <Form query_f = {createSetting} {...props}/>
      )}
    </Mutation>
  );
};

export default Add;